import { APP_ROUTES, PROFILE_ROUTE_SEGMENTS } from '@routes/routes.constants';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import type { UseProfileNavigationReturn } from './useProfileNavigation.types';

const PERSONAL_INFORMATION_PATH = `${APP_ROUTES.PROFILE}/${PROFILE_ROUTE_SEGMENTS.PERSONAL_INFORMATION}`;
const EDIT_IDENTITY_PATH = `${PERSONAL_INFORMATION_PATH}/${PROFILE_ROUTE_SEGMENTS.EDIT_IDENTITY}`;
const EDIT_CONTACT_PATH = `${PERSONAL_INFORMATION_PATH}/${PROFILE_ROUTE_SEGMENTS.EDIT_CONTACT}`;
const EDIT_OTHER_INFORMATION_PATH = `${PERSONAL_INFORMATION_PATH}/${PROFILE_ROUTE_SEGMENTS.EDIT_OTHER_INFORMATION}`;
const EDIT_CITIZENSHIP_PATH = `${PERSONAL_INFORMATION_PATH}/${PROFILE_ROUTE_SEGMENTS.EDIT_CITIZENSHIP}`;

export function useProfileNavigation(): UseProfileNavigationReturn {
  const navigate = useNavigate();

  const navigateToPersonalInformation = React.useCallback((): void => {
    navigate(PERSONAL_INFORMATION_PATH);
  }, [navigate]);

  const navigateToEditIdentity = React.useCallback((): void => {
    navigate(EDIT_IDENTITY_PATH);
  }, [navigate]);

  const navigateToEditContact = React.useCallback((): void => {
    navigate(EDIT_CONTACT_PATH);
  }, [navigate]);

  const navigateToEditOtherInformation = React.useCallback((): void => {
    navigate(EDIT_OTHER_INFORMATION_PATH);
  }, [navigate]);

  const navigateToEditCitizenship = React.useCallback((): void => {
    navigate(EDIT_CITIZENSHIP_PATH);
  }, [navigate]);

  return { navigateToPersonalInformation, navigateToEditIdentity, navigateToEditContact, navigateToEditCitizenship, navigateToEditOtherInformation };
}
